<div id="layout-wrapper" [ngClass]="{ collapsed: isSidebarCollapsed }" (click)="layoutClicked()">
  <div class="OpenCloseSidebar" [ngClass]="{ collapsed: isSidebarCollapsed }" (click)="toggleSidebar()">
    <img [class.rotated]="isSidebarCollapsed" src="../../../assets/icons/sidebar/right-arrow.svg" alt="" />
  </div>
  <app-sidebar></app-sidebar>
  <div class="main-content">
    <div class="page-content">
      <div class="page-container">
        @if (readOnlyBanner) {
        <div class="read-only-banner" role="status" data-testid="read-only-banner">{{ readOnlyBanner }}</div>
        }
        <app-topbar></app-topbar>
        <div class="cover-header"></div>
        <div
          class="component-wrapper"
          [ngClass]="{ 'panel-open': activePanel }"
          [style.--panel-width]="getPanelWidth() + 'px'"
        >
          <div class="main-content-area">
            <app-loader></app-loader>
            <router-outlet></router-outlet>
          </div>

          <!-- Dynamic Panel Sidebar -->
          @if (activePanel) {
          <div class="toolkit-panel-sidebar" [ngClass]="{ 'slide-out': panelClosing }">
            <!-- Copilot Panel -->
            @if (activePanel === 'copilot') {
            <app-copilot
              (iscloseModal)="onPanelClose($event)"
              (expandToggle)="onExpandToggle($event)"
              [isExpanded]="expandedPanel"
              [triggerElement]="getTriggerElement('copilot')"
            />
            }
          </div>
          }

          <!-- Tool Kit sideBar (always on the right) -->
          <div class="toolkit-sidebar">
            @for (toolkit of toolKitList; track toolkit) {
            <span class="sideBar" [ngClass]="{ active: activePanel === toolkit.id }" (click)="navigateTo(toolkit)">
              <img
                #toolkitIcon
                [src]="activePanel === toolkit.id ? toolkit.activeIcon : toolkit.icon"
                height="20"
                [alt]="toolkit.altName"
                [title]="toolkit.tooltiptext"
              />
            </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
